import { forwardRef, ReactNode } from 'react'

import { Polymorphic } from '../../../utils/PolymorphicUtils'
import { Stack } from '../stack/Stack'
import { Typography, TypographyProps } from '../typography/typography'

export type LinkProps = Pick<TypographyProps, 'emphasis'> & {
  iconStart?: ReactNode
  iconEnd?: ReactNode
}

export const Link = forwardRef(function Link(
  { as, emphasis, iconStart, iconEnd, className, children, ...props },
  ref,
) {
  return (
    <Stack
      as={as ?? 'a'}
      align="center"
      gap={2 * 4}
      className={`transition underline ${className ?? ''} hover:opacity-80 cursor-pointer`}
      {...props}
      ref={ref}
    >
      {iconStart || undefined}
      <Typography scale="body-small" emphasis={emphasis}>
        {children}
      </Typography>
      {iconEnd || undefined}
    </Stack>
  )
}) as Polymorphic<'a', LinkProps>
